import { AgentDatasetSchema } from "@redotech/redo-model/agents/agent-dataset";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const removeItemFromDataset = {
  name: "removeItemFromDataset" as const,
  input: z.object({
    _id: zExt.objectId(),
    initializationInputId: zExt.objectId(),
  }),
  output: AgentDatasetSchema,
};
